import { useSelector } from 'react-redux';
import {
  pageItemsSelector,
  projectMetadataSelector,
  projectPKSelector,
} from '../reducers/selectors';
import { useCallback } from 'react';
import { app2Service, getPageForRenderer } from './zoomServices';
import { pageToLayout } from './pageToLayout';

export function useSaveAccountLayout(pageId) {
  const projectPK = useSelector(projectPKSelector);
  const project = useSelector(projectMetadataSelector);
  const pageItemObjects = useSelector(pageItemsSelector);
  return useCallback(
    async (name) => {
      const page = await getPageForRenderer(projectPK, pageId);
      const productID = project.getIn(['product', 'id']);
      const layout = pageToLayout({
        page,
        name,
        pageItemObjects,
        includeMirroredVersion: false,
      });
      await app2Service().post('/userProject/addLayout', {
        productID,
        layout,
      });
    },
    [pageId, projectPK, project, pageItemObjects],
  );
}
